import React, { useState } from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import { useLocation } from 'react-router-dom';
import BalanceLayout from "./components/balance_layout";

const MelonBalancePage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState({
        option_value : queryParams.get("option_value"),
    })

    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <BalanceLayout default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default MelonBalancePage;